import React from 'react';
import {Col, Layout} from "antd";
import {Content} from "antd/es/layout/layout";
import './style.scss'
import {AccountIcon, ArtIcon, DashboardIcon, LibIcon} from "../../DashBoard/imgs/Icons";

const Navigator = (props) => {
    const {active} = props
    return (
        <Col lg={4} className={'bp-nav'}>
            <div className={'bp-one-nav'}
                 style={{
                     marginTop: '3rem',
                     // backgroundColor:'#051d37'
                 }}>
                <DashboardIcon/>
                <p className={'bp-nav-txt'}>Dashboard</p>
            </div>
            <div className={'bp-one-nav'}>
                <LibIcon/>
                <p className={'bp-nav-txt'}>My Library</p>
            </div>
            <div className={'bp-one-nav'}>
                <ArtIcon/>
                <p className={'bp-nav-txt'}>Discover Art</p>
            </div>
            <div className={'bp-one-nav'}>
                <AccountIcon/>
                <p className={'bp-nav-txt'}>My Account</p>
            </div>
        </Col>
    )
}

export default Navigator;
